import { render, staticRenderFns } from "./crudCategories.vue?vue&type=template&id=6cd3e04e&scoped=true"
import script from "./crudCategories.vue?vue&type=script&lang=js"
export * from "./crudCategories.vue?vue&type=script&lang=js"
import style0 from "./crudCategories.vue?vue&type=style&index=0&id=6cd3e04e&prod&lang=css"
import style1 from "./crudCategories.vue?vue&type=style&index=1&id=6cd3e04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3e04e",
  null
  
)

export default component.exports